<template>
  <div class="header-wrap">
    <!-- 提示信息 -->
    <div v-if="showConstructionTip" class="construction-tip">
      {{ t("header.constructionTip") }}
    </div>

    <div class="main-content" v-show="!isMenuOpen">
      <div class="left-bar">
        <router-link to="/">
          <img src="../assets/image/logo.png" alt="Logo" class="logo" />
        </router-link>
        <div class="texts">
          <div class="nav-item" @mouseenter="openDropdown('aboutCompany')" @mouseleave="closeDropdown">
              <router-link to="/about" @click.prevent>
             {{ t("header.aboutCompany") }}
       </router-link>
        
            <span class="dropdown-arrow">
              <svg viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg" class="chevron" data-v-85ab4af4="">
                <path d="M9 1.66667L5 5.66667L1 1.66667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round"></path>
              </svg>
            </span>
            <div v-if="activeDropdown === 'aboutCompany'" class="dropdown-menu">
              <div class="dropdown-item">
                              <router-link to="/about/strategicgoals" @click.prevent>
             {{ t("header.vision") }}
       </router-link>
              </div>
              <div class="dropdown-item">
                                          <router-link to="/about/partner" @click.prevent>
             {{ t("header.partaens") }}
       </router-link>
              </div>
            </div>
          </div>
          <div class="nav-item" @mouseenter="openDropdown('solutions')" @mouseleave="closeDropdown">
            {{ t("header.solutions") }}
            <span class="dropdown-arrow">
              <svg viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg" class="chevron" data-v-85ab4af4="">
                <path d="M9 1.66667L5 5.66667L1 1.66667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round"></path>
              </svg>
            </span>
            <div v-if="activeDropdown === 'solutions'" class="dropdown-menu">
              <div class="dropdown-item">
                <a href="https://www.ourproteinfactory.com/" target="_blank">
                  {{ t("header.proteinn") }}</a>
              </div>
              <div class="dropdown-item">
                <a href="https://www.d2plab.com" target="_blank">{{
                  t("header.d2plab")
                }}</a>
              </div>
              <div class="dropdown-item">
                <a href="https://www.ystemed.com/home" target="_blank">{{ t("header.cosmeticMedicine")
                }}</a>
              </div>
              <div class="dropdown-item">
                <a href="https://www.thelightofdesert.com/" target="_blank">{{ t("header.desert")
                }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 桌面端导航 -->
      <div class="desktop-nav">
        <div class="nav-item">
          <router-link to="/news" @click.prevent>{{
            t("header.news")
          }}</router-link>
        </div>

        <div class="nav-item">
          <a href="mailto:hr@healthcodon.com">
            {{ t("header.careers") }}
          </a>
        </div>

        <div class="nav-item" @mouseenter="openDropdown('language')" @mouseleave="closeDropdown">
          {{ t("header.language") }}
          <span class="dropdown-arrow">
            <svg viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg" class="chevron" data-v-85ab4af4="">
              <path d="M9 1.66667L5 5.66667L1 1.66667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round"></path>
            </svg>
          </span>
          <div v-if="activeDropdown === 'language'" class="dropdown-menu">
            <div class="dropdown-item" @click="switchLanguage('zh')">中文</div>
            <div class="dropdown-item" @click="switchLanguage('en')">
              English
            </div>
          </div>
        </div>

        <div class="nav-item contact-btn">
          <a href="mailto:international@healthcode.com?">
            <span>{{ t("header.contact") }}</span>
            <span class="arrow-icon"><svg data-v-a41d480e="" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg" data-v-f316e37b="">
                <path data-v-a41d480e="" d="M13 8.66671L16.3333 12L13 15.3334" stroke="currentColor" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round"></path>
                <path data-v-a41d480e="" d="M16.3334 12L7.66675 12" stroke="currentColor" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round"></path>
              </svg></span>
          </a>
        </div>
      </div>

      <!-- 移动端菜单按钮 -->
      <div class="mobile-menu-btn" @click="toggleMobileMenu">
        <div class="hamburger-icon">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>

    <!-- 移动端侧边栏菜单 -->
    <transition name="sidebar-overlay">
      <div v-if="isMenuOpen" class="mobile-sidebar-overlay" @click="closeMobileMenu">
        <transition name="sidebar-slide">
          <div v-if="isMenuOpen" class="mobile-sidebar" @click.stop>
            <div class="sidebar-content">
              <div class="sidebar-header">
                <div class="close-btn" @click="closeMobileMenu">&times;</div>
              </div>

              <div class="sidebar-menu" ref="sidebarMenu">
                <!-- 关于公司 -->
                <div class="sidebar-item animated-item" @click="toggleMobileDropdown('aboutCompany')">
                  <div class="sidebar-item-content">
                   <router-link to="/about" @click="closeMobileMenu">  {{ t("header.aboutCompany") }}</router-link>
                  </div>
                  <span class="dropdown-arrow" :class="{ 'rotated': mobileDropdowns.aboutCompany }">
                    <svg viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg" class="chevron"
                      data-v-85ab4af4="">
                      <path d="M9 1.66667L5 5.66667L1 1.66667" stroke="currentColor" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </span>
                </div>
                
                <div class="mobile-submenu-container" :class="{ 'expanded': mobileDropdowns.aboutCompany }">
                  <div v-if="mobileDropdowns.aboutCompany" class="mobile-submenu animated-item submenu-offset">
                    <div class="submenu-item" >      <router-link to="/about/strategicgoals" @click="closeMobileMenu">
             {{ t("header.vision") }}
       </router-link></div>
                    <div class="submenu-item">       <router-link to="/about/partner" @click="closeMobileMenu">
             {{ t("header.partaens") }}
       </router-link></div>
                  </div>
                </div>

                <!-- 解决方案 -->
                <div class="sidebar-item animated-item" @click="toggleMobileDropdown('solutions')">
                  <div class="sidebar-item-content">
                    {{ t("header.solutions") }}
                  </div>
                  <span class="dropdown-arrow" :class="{ 'rotated': mobileDropdowns.solutions }">
                    <svg viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg" class="chevron"
                      data-v-85ab4af4="">
                      <path d="M9 1.66667L5 5.66667L1 1.66667" stroke="currentColor" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </span>
                </div>
                
                <div class="mobile-submenu-container" :class="{ 'expanded': mobileDropdowns.solutions }">
                  <div v-if="mobileDropdowns.solutions" class="mobile-submenu animated-item submenu-offset">
                    <div class="submenu-item"><a href="https://www.ourproteinfactory.com/" target="_blank" @click="closeMobileMenu"> {{ t("header.proteinn") }}</a>
                    </div>
                    <div class="submenu-item"><a href="https://www.d2plab.com/home" target="_blank" @click="closeMobileMenu">{{ t("header.d2plab") }}</a> </div>
                    <div class="submenu-item"> <a href="https://www.ystemed.com/home" target="_blank" @click="closeMobileMenu">{{ t("header.cosmeticMedicine") }}</a>
                    </div>
                    <div class="submenu-item"> <a href="https://www.thelightofdesert.com/" target="_blank" @click="closeMobileMenu">{{ t("header.desert") }}</a></div>
                  </div>
                </div>

                <!-- 新闻 -->
                <div class="sidebar-item animated-item">
                  <router-link to="/news" @click="closeMobileMenu" class="sidebar-item-content">{{ t("header.news") }}</router-link>
                </div>

                <!-- 职业 -->
                <div class="sidebar-item animated-item">
                  <a href="mailto:hr@healthcodon.com" class="sidebar-item-content" @click="closeMobileMenu">
                    {{ t("header.careers") }}
                  </a> 
                </div>

                <!-- 联系 -->
                <div class="sidebar-item animated-item">
                  <a href="mailto:international@healthcode.com" class="sidebar-item-content" @click="closeMobileMenu">
                    {{ t("header.contact") }}
                  </a>
                </div>

                <!-- 语言 -->
                <div class="sidebar-item animated-item" @click="toggleMobileDropdown('language')">
                  <div class="sidebar-item-content">
                    {{ t("header.language") }}
                  </div>
                  <span class="dropdown-arrow" :class="{ 'rotated': mobileDropdowns.language }">
                    <svg viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg" class="chevron"
                      data-v-85ab4af4="">
                      <path d="M9 1.66667L5 5.66667L1 1.66667" stroke="currentColor" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </span>
                </div>
                
                <div class="mobile-submenu-container" :class="{ 'expanded': mobileDropdowns.language }">
                  <div v-if="mobileDropdowns.language" class="mobile-submenu animated-item submenu-offset">
                    <div class="submenu-item" @click="switchLanguage('zh')">中文</div>
                    <div class="submenu-item" @click="switchLanguage('en')">
                      English
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from "vue";
import { useI18n } from "vue-i18n";

defineOptions({
  name: "AppHeader",
});

const { locale, t } = useI18n();

// 定义响应式数据
const isMenuOpen = ref(false);
const activeDropdown = ref("");
const mobileDropdowns = ref({
  aboutCompany: true,
  solutions: true,
  language: true,
});
const sidebarMenu = ref(null);
const showConstructionTip = ref(false);

// 显示建设中提示
const showConstructionMessage = () => {
  showConstructionTip.value = true;
  closeMobileMenu();
  
  // 5秒后隐藏提示
  setTimeout(() => {
    showConstructionTip.value = false;
  }, 5000);
};

// 桌面端下拉菜单控制
const openDropdown = (name) => {
  activeDropdown.value = name;
};

const closeDropdown = () => {
  activeDropdown.value = "";
};

// 触发菜单项动画
const triggerAnimation = () => {
  nextTick(() => {
    const items = sidebarMenu.value?.querySelectorAll('.animated-item');
    if (items) {
      items.forEach((item, index) => {
        item.style.opacity = '0';
        item.style.transform = 'translateY(-20px)';
        
        setTimeout(() => {
          item.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
          item.style.opacity = '1';
          item.style.transform = 'translateY(0)';
        }, index * 100);
      });
    }
  });
};

// 移动端菜单控制
const toggleMobileMenu = () => {
  if (!isMenuOpen.value) {
    isMenuOpen.value = true;
    document.body.style.overflow = 'hidden';
    setTimeout(triggerAnimation, 50);
  } else {
    closeMobileMenu();
  }
};

const closeMobileMenu = () => {
  // 触发关闭动画
  isMenuOpen.value = false;
  // 延迟重置body样式，确保动画完成
  setTimeout(() => {
    document.body.style.overflow = '';
  }, 300);
};

// 移动端下拉菜单切换
const toggleMobileDropdown = (name) => {
  mobileDropdowns.value[name] = !mobileDropdowns.value[name];
};

// 切换语言
const switchLanguage = (lang) => {
  locale.value = lang;
  closeMobileMenu();
};
</script>

<style scoped>

.header-wrap {
  position: fixed;
  top: 0;
  align-items: center;
  -webkit-backdrop-filter: blur(16px);
  backdrop-filter: blur(16px);
  background: #0000004d;
  color: #fff;
  display: flex;
  flex-direction: row;
  height: var(--nav-height);
  justify-content: center;
  width: 100%;
  z-index: 1000;
  overflow: visible;
}

.construction-tip {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 1.5rem;
  border-radius: 8px;
  font-size: 1.2rem;
  z-index: 10000;
  animation: fadeInOut 5s ease-in-out;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.8);
  }
  15% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  85% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.8);
  }
}

.main-content {
  font-size: 12px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1920px;
  padding-inline: 6rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 7rem;
  position: relative;
}

.left-bar {
  display: flex;
  align-items: center;
  gap: 20px;
}

.logo {
  height: 3.2rem;
}

.texts {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.desktop-nav {
  display: flex;
  gap: 10px;
  align-items: center;
}

.nav-item {
  position: relative;
  cursor: pointer;
  padding: 8px 5px;
  z-index: 1001;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 1.15rem;
}

.nav-item:hover .dropdown-arrow {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  /* min-width: 180px; */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1002;
  animation: dropdownFade 0.3s ease;
   white-space: nowrap;
}

@keyframes dropdownFade {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdown-item {
  padding: 5px 16px;
  transition: background 0.2s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.dropdown-item a {
  display: flex;
  flex-direction: column;
}

.dropdown-item:hover {
  background: rgba(255, 255, 255, 0.1);
}

.mobile-menu-btn {
  display: none;
  cursor: pointer;
}

.hamburger-icon span {
  display: block;
  width: 25px;
  height: 3px;
  background: white;
  margin: 5px 0;
  transition: 0.4s;
}

/* 菜单整体过渡动画 */
.sidebar-overlay-enter-active,
.sidebar-overlay-leave-active {
  transition: opacity 0.3s ease;
}

.sidebar-overlay-enter-from,
.sidebar-overlay-leave-to {
  opacity: 0;
}

.sidebar-overlay-enter-to,
.sidebar-overlay-leave-from {
  opacity: 1;
}

/* 侧边栏滑动动画 */
.sidebar-slide-enter-active,
.sidebar-slide-leave-active {
  transition: transform 0.3s ease;
}

.sidebar-slide-enter-from,
.sidebar-slide-leave-to {
  transform: translateX(100%);
}

.sidebar-slide-enter-to,
.sidebar-slide-leave-from {
  transform: translateX(0);
}

/* 优化后的子菜单动画容器 */
.mobile-submenu-container {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-submenu-container.expanded {
  max-height: 500px; 
}

.mobile-submenu {
  align-items: flex-start;
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
  background: #0003;
  border: 1px solid hsla(0, 0%, 100%, .1);
  padding:1rem;
  margin-top: 0.5rem;
  border-radius: 8px;
  opacity: 0;
  transform: translateY(-10px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.mobile-submenu-container.expanded .mobile-submenu {
  opacity: 1;
  transform: translateY(0);
}

.submenu-item {
  padding: 0.5rem 0;
  color: #fff;
  cursor: pointer;
  font-size: 1.3rem;
  transition: opacity 0.2s ease;
}

.submenu-item:hover {
  opacity: 0.8;
}

.submenu-item:last-child {
  border-bottom: none;
}

/* 修复移动端侧边栏样式 */
.mobile-sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.7);
  -webkit-backdrop-filter: blur(20px) brightness(0.3);
  backdrop-filter: blur(20px) brightness(0.3);
}

.mobile-sidebar {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  background: transparent;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.3);
}

.sidebar-content {
  height: 100%;
  padding: 20px;
  overflow-y: auto;
}

.sidebar-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #333;
}

.close-btn {
  font-size: 30px;
  cursor: pointer;
  color: white;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.close-btn:hover {
  transform: scale(1.1);
}

.sidebar-menu {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.sidebar-item {
  padding: 0.5rem 0;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  font-size: 1.4rem;
  margin-top: 0.6rem;
  transition: background-color 0.2s ease;
}

.sidebar-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.sidebar-item-content {
  flex: 1;
  text-decoration: none;
  color: inherit;
  padding: 0;
  font-size: 1.4rem;
}

/* 移动端下拉箭头旋转动画 */
.dropdown-arrow {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: center;
  padding: 0.5rem;
}

.dropdown-arrow.rotated {
  transform: rotate(180deg);
}

.contact-btn {
  align-items: center;
  background: #000;
  border-radius: 2.4rem;
  color: #fffc;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  height: 2.8rem;
  justify-content: center;
  padding-inline: 1.4rem 1rem;
  transition: all 0.2s ease-in-out;
  width: fit-content;
  background: none;
  border: 1px solid hsla(0, 0%, 100%, 0.1);
  color: #fff;
}

.contact-btn a {
  display: flex;
}

/* 下拉箭头统一用伪元素绘制 */
.chevron {
  color: #fff;
  width: .8rem;
}

.dropdown-arrow,
.mobile-arrow {
  display: inline-block;
  margin-left: 6px;
  vertical-align: middle;
  transition: transform 0.3s ease;
}

.nav-item:hover .dropdown-arrow {
  transform: rotate(180deg);
}

.smalltext {
  font-size: 0.8rem;
}

/* 子菜单缩进样式 */
.submenu-offset {
  margin-left: 1rem;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .logo {
  height: 3.8rem;
}
  .desktop-nav {
    display: none;
  }

  .mobile-menu-btn {
    display: block;
  }

  .main-content {
    padding-inline: 2rem;
  }

  .texts {
    display: none;
  }
  
  .smalltext {
    font-size: 1.1rem;
  }
  
  .sidebar-header {
    border-bottom: none;
    padding-bottom: 1rem;
  }
  
  /* 移动端提示样式调整 */
  .construction-tip {
    font-size: 1.2rem;
    padding: 15px 25px;
    width: 80%;
    text-align: center;
  }
  
  /* 汉堡菜单动画 */
  .hamburger-icon span {
    transition: 0.4s;
  }
  
  .hamburger-icon.active span:nth-child(1) {
    transform: rotate(-45deg) translate(-5px, 6px);
  }
  
  .hamburger-icon.active span:nth-child(2) {
    opacity: 0;
  }
  
  .hamburger-icon.active span:nth-child(3) {
    transform: rotate(45deg) translate(-5px, -6px);
  }
  
  /* 优化移动端子菜单动画 */
  .mobile-submenu-container {
    transition: max-height 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  
  .mobile-submenu {
    transition: opacity 0.25s ease, transform 0.25s ease;
  }
}
</style>